<template>
    <section class="col-xs-12 col-sm-5">
        <div class="calendar__info">
            <div class="calendar__info">
                <div class="calendar__info__item">
                    <h4 class="calendar__info__title">{{ $t('LAST_PERIOD') }}</h4>
                    <div class="calendar__info__date__wrapper">
                        <div class="calendar__info__date">
                            <span>{{ lastPeriodDay | moment('dd') }}</span>
                            <span class="date__day-number">{{ lastPeriodDay | moment('DD') }}</span>
                        </div>
                        <div class="calendar__info__month">
                            <span>{{ lastPeriodDay | moment('MMM') }} {{ lastPeriodDay | moment('YYYY') }}</span>
                        </div>
                    </div>

                    <div class="calendar__info__tooltip box-shadow">
                        {{ $t('FIRST_PERIOD_DAY_INFO') }}
                        <!--<strong>{{ $t('CLICK_CALENDAR')}}</strong>-->
                    </div>
                </div>
                <div class="calendar__info__item">
                    <div class="next-examination__wrapper">
                        <h4 class="calendar__info__title">{{ $t('LAST_BRASTER_EXAMINATION') }}:</h4>

                        <div class="next-examination__legend next-examination__legend--transparent">
                            <img class="legend-img" src="../../assets/images/braster-logo-app.png" />
                        </div>

                        <div class="next-examination__date">
                            {{ dateFormat(lastExamination.isoDate) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        lastExamination: Object,
        lastPeriodDay: String,
    },
    data() {
        return {};
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// last-period-and-examination.vue?4bc95375